/*
  biberna - Varianten-Matching fuer den Set-Konfigurator (BIB-AOV-1).

  Bewusst eine eigene Datei: reine Logik, kein DOM, kein fetch. Dadurch
  laesst sie sich direkt testen (test-derive.cjs laedt genau DIESE Datei,
  nicht eine Kopie) und der Wortlaut der Hinweise laesst sich aendern,
  ohne die 500 Zeilen von biberna-bundle.js anzufassen.

  Aufgabe: Zu der auf der Seite gewaehlten Bettwaesche-Variante die
  passende Zubehoer-Variante finden. Regeln liegen in
  snippets/biberna-set-rules.liquid.

  ZWEI ENTSCHEIDUNGEN, DIE HIER FESTGESCHRIEBEN SIND

  1. Groesse schlaegt Farbe.
     Eine falsche Farbe ist ein Kompromiss, eine falsche Groesse ist eine
     Retoure. Findet sich die Wunschfarbe in der Zielgroesse nicht, wird
     die Farbe getauscht - nie die Groesse.

  2. Gibt es eine Groessenregel, deren Groesse das Zielprodukt gar nicht
     fuehrt, endet die Suche mit null. Beispiel: Kinderbett (100x135)
     gegen das Erwachsenen-Feinjersey, das erst bei 90x190 anfaengt. Der
     aufrufende Code schaltet den Slot dann ab. Ein 90x190-Laken zu einem
     60x120-Kinderbett waere schlimmer als gar kein Vorschlag.

  Der Rueckgabewert traegt mit, WIE der Treffer zustande kam - damit der
  Hinweis auf der Seite nichts behaupten kann, was nicht stimmt:
    via 'exact'    Wunschfarbe, lieferbar
    via 'fallback' abgestimmter Ersatzton aus colorFallback
    via 'neutral'  neutraler Rueckfall (Weiss/Natur/...) aus neutralDefault
    reason 'size-only'  gar keine Farbe der Kette lieferbar, nur Groesse
    reason 'color-only' keine Groessenregel vorhanden, nur Farbe
*/
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.bibernaSetMatch = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function find(live, color, size) {
    for (var i = 0; i < live.length; i++) {
      if (color !== null && live[i].color !== color) continue;
      if (size !== null && live[i].size !== size) continue;
      return live[i];
    }
    return null;
  }

  function deriveSelection(bedding, live, withColor, rules) {
    if (!bedding || !live || !live.length) return null;
    rules = rules || {};

    var sizeMap = rules.sizeMap || {};
    var fallback = (rules.colorFallback || {})[bedding.color] || [];
    var neutral = rules.neutralDefault || [];

    var sizes = sizeMap[bedding.size] || [];
    var colors = [bedding.color].concat(fallback).concat(neutral);

    var i, j, hit;

    if (sizes.length) {
      for (i = 0; i < colors.length; i++) {
        for (j = 0; j < sizes.length; j++) {
          hit = find(live, withColor ? colors[i] : null, sizes[j]);
          if (hit) {
            return {
              color: hit.color,
              size: hit.size,
              exact: i === 0,
              via: i === 0 ? 'exact' : (i <= fallback.length ? 'fallback' : 'neutral'),
              reason: 'match'
            };
          }
        }
      }
      for (j = 0; j < sizes.length; j++) {
        hit = find(live, null, sizes[j]);
        if (hit) {
          return { color: hit.color, size: hit.size, exact: false, via: 'neutral', reason: 'size-only' };
        }
      }
      /* Groessenregel vorhanden, Zielprodukt fuehrt sie nicht - siehe Kopf. */
      return null;
    }

    if (withColor) {
      for (i = 0; i < colors.length; i++) {
        hit = find(live, colors[i], null);
        if (hit) {
          return {
            color: hit.color,
            size: hit.size,
            exact: i === 0,
            via: i === 0 ? 'exact' : (i <= fallback.length ? 'fallback' : 'neutral'),
            reason: 'color-only'
          };
        }
      }
    }

    return null;
  }

  /* Der Satz ueber dem Zubehoer. Er ist der eigentliche Verkaufsmoment -
     und genau deshalb darf er nie mehr versprechen als eingetreten ist.
     Am 12.09.2026 stand auf der Feuerwehr-Garnitur "Passend zu
     Pistaziengruen" ueber einem weissen Laken, weil Pistaziengruen in
     90x190-100x200 ausverkauft ist.

     20.09.2026 - WEM GEHOERT DIE GROESSE IM HINWEIS?
     Der Satz steht ueber dem VORGESCHLAGENEN Artikel, nannte aber immer
     die Groesse des SEITENPRODUKTS. Auf einer Spannbettlaken-Seite las
     sich der Hinweis ueber dem Bettwaesche-Vorschlag deshalb als
     "Passend zu Weiss, 1x 180x200 cm - 200x200 cm" - ein Matratzenmass
     ueber einer Bettwaesche, die es in diesem Mass gar nicht gibt.
     ownLabel benennt jetzt, WOZU die Groesse gehoert ("Spannbettlaken
     1x 180x200 cm - 200x200 cm"). Der Parameter ist optional: fehlt er,
     verhaelt sich die Funktion wie bisher, statt "undefined" zu zeigen. */
  function matchHintText(bedding, s, ownLabel) {
    if (!bedding || !bedding.color || !bedding.size || !s) return '';

    var anchor = ownLabel ? ownLabel + ' ' + bedding.size : bedding.size;

    if (s.reason === 'color-only') {
      return 'Farblich abgestimmt auf ' + bedding.color;
    }
    if (s.via === 'exact') {
      return 'Passend zu: ' + anchor + ', ' + bedding.color;
    }
    if (s.via === 'fallback') {
      return 'Passend zu: ' + anchor + ' · ' + s.color + ' ist der abgestimmte Ton zu ' + bedding.color;
    }
    return 'Passend zu: ' + anchor + ' · ' + bedding.color + ' ist bei diesem Artikel gerade nicht lieferbar';
  }

  return { deriveSelection: deriveSelection, matchHintText: matchHintText };
}));
